module.exports = require("ngx-toastr");